export class FileInputEvent
{
	public static FILE_ADDED: string = "component:fileinput:file_added";
	public static FILES_ADDED: string = "component:fileinput:files_added";
	public static FILE_REMOVED: string = "component:fileinput:file_removed";
	public static FILE_MAX_SIZE_EXCEEDED: string = "component:fileinput:file_max_size_exceeded";
	public static FILE_TYPE_INVALID: string = "component:fileinput:file_type_invalid";
}